import { render } from "./productGridColumnedBlock.vue?vue&type=template&id=dbc3b764&ts=true"
import script from "./productGridColumnedBlock.vue?vue&type=script&lang=ts"
export * from "./productGridColumnedBlock.vue?vue&type=script&lang=ts"

import "./productGridColumnedBlock.vue?vue&type=style&index=0&id=dbc3b764&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__